export default __webpack_public_path__ + "static/media/klinik.a3d05926.png";